// Package IDs for the Visitor licenses (used when requesting additional
// Visitor licenses via RequestLicensesModal / RequestLicensesInlineMessage).
export const visitorSmallPackageId = 195;
export const visitorMediumPackageId = 196;
export const visitorLargePackageId = 197;

// Selects the correct Visitor package tier based on the requested user count:
// under 100 users -> Small, 100-500 users -> Medium, over 500 users -> Large.
export const getVisitorPackageId = (userCount: number): number => {
  if (userCount > 500) {
    return visitorLargePackageId;
  }

  if (userCount >= 100) {
    return visitorMediumPackageId;
  }

  return visitorSmallPackageId;
};
